import * as pathToRegexp from 'path-to-regexp'

import { exists } from './exists'

/**
 * パスのパラメータを解析します。
 *
 * @param pathname - パス。
 * @param pattern - パターン。
 * @param start - パターンの先頭からマッチさせるかどうか。
 * @returns パスのパラメータ。
 */
export function getMatchedParams<Pattern extends string>(
  pathname: string,
  pattern: Pattern,
  start = false,
): AnalyzePathParams<Pattern> | undefined {
  const keys: pathToRegexp.Key[] = []
  const regexp = pathToRegexp.pathToRegexp(pattern, keys, {
    end: false,
    start,
  })
  const match = regexp.exec(pathname)
  if (!exists(match)) {
    return undefined
  }

  const [, ...values] = match

  return keys.reduce(
    (prev, key, index) =>
      key.name !== '_'
        ? {
            ...prev,
            [key.name]: values[index],
          }
        : prev,
    {} as AnalyzePathParams<Pattern>,
  )
}
